/**
 * 统计事件 ID 汇总
 *
 * 《埋点数据字典》，可复制链接后用石墨文档 App 或小程序打开
 *
 * @link https://shimo.im/docs/GPdgj8vdrWYJttyT/
 */
export const eventIdMap = {
  // 以下示例在实际项目中可移除
  /** 进入活动首页 */
  ENTER_ACTIVITY_MAIN: 'enter-activity-main',
}
